import React from "react"
import './App.css';
import { Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import Login from './components/Users/login';
import BankOwnerBanks from './components/Users/bank_owners/BankOwnerBanks';
import CommunCustomer from './components/Users/bank_owners/Communicate/CommunicateCustomer';
import CommunFarmer from './components/Users/bank_owners/Communicate/CommunFarmer';
import CommunicateAdmin from './components/Users/bank_owners/Communicate/CommunAdmins';
import CommunBankOwner from './components/Users/bank_owners/Communicate/Communicate';
import CustomerDashboard from './components/Users/customers/customerDashboard';
import CustomerCommunicateHotelOwners from './components/Users/customers/CommunicateCustomer/CustomerCommunicateHotelOwner';
import Home from './components/Home';
import AdminBanksFun from './components/Users/Admins/AdminBanks';
import AdminTransporters from './components/Users/Admins/AdminTransporters';
import AdminHotelsFunc from './components/Users/Admins/AdminHotels';
import Communicate from './components/Users/Admins/Communicate/communicate';
import CommunicateBankOwner from './components/Users/Admins/Communicate/CommunicateBankOwner';
import CommunicateCustomer from './components/Users/Admins/Communicate/CommunicateCustomers';
import CommunicateFarmers from './components/Users/Admins/Communicate/CommunicateFarmers';
import CommunicateHotelOwners from './components/Users/Admins/Communicate/CommunicateHotelOwners';
import CommunicateTransportOwners from './components/Users/Admins/Communicate/CommunicateTO';
import BankOwnerDashboard from './components/Users/bank_owners/bankOwnerDashboard';
import BankOwnerProvider from './components/Users/bank_owners/BankOwnerContext';
import BankOwnerDashLP from './components/Users/bank_owners/BankOwneDashLandingPage';
import FarmerDashboard from './components/Users/farmers/farmerDashboard';
import FarmerComunAdmin from './components/Users/farmers/Communicate/FarmerCommunAdmins';
import HotelOwnerDashboard from './components/Users/hotelOwners/hotelOwner';
import { HotelOwnerProvider } from './components/Users/hotelOwners/HotelOwnerContext';
import HotelOwnerHotels from './components/Users/hotelOwners/HotelOwnerHotels';
import HotelOwnerCommunicate from './components/Users/hotelOwners/CommunicateHotelOwner/HotelOwnerCommunicateFarmer';
import HotelOwnerCommunCustomer from './components/Users/hotelOwners/CommunicateHotelOwner/HotelOwnerCommunicateCustomer';
import HotelOnwerCommunAdmin from './components/Users/hotelOwners/CommunicateHotelOwner/HotelOnwerCommunAdmins';
import HotelOwnerCommunFarmer from './components/Users/hotelOwners/CommunicateHotelOwner/HotelOwnerCommunFarmers';
import HotelOwnerDashLP from './components/Users/hotelOwners/HotelOwnerDashLP';
import TransportOwnerDashboard from './components/Users/transportOwners/TransportOwnerDashboard';
import Register from './components/Users/register';
import AdminDashboard from './components/Users/Admins/adminDashboard';
import AdminDashLandingPage from './components/Users/Admins/ADLandingPage';
import Unauthorized from './components/Users/Unauthorized';
import About from './components/About';
import Contact from './components/Contact';
import Logout from './components/logout';
import { AdminProvider } from './components/Users/Admins/AdminDashContext';
import { CustomerProvider } from './components/Users/customers/CustomerContext';
import CustomerBanks from './components/Users/customers/customerBanks';
import CustomerHotels from './components/Users/customers/CustomerHotel';
import CustomerFarmers from './components/Users/customers/CustomerFarmer';
import CustomerTransporter from './components/Users/customers/CustomerTransporters';
import CustomerCommun from './components/Users/customers/CommunicateCustomer/CommunicateCustomers';
import CustomerCommunBankOwner from './components/Users/customers/CommunicateCustomer/CommunicateBankOwners';
import CustomerCommunTransOwners from './components/Users/customers/CommunicateCustomer/CustomerCommunTransOwners';
import CustomerDashLP from './components/Users/customers/CustomerDashLP';
import CommunicateFarmer from './components/Users/customers/CommunicateCustomer/CommunicateFarmers';
import CustomerCommunAdmins from './components/Users/customers/CommunicateCustomer/CustomerCummunAdmins';
import { FarmerProvider } from './components/Users/farmers/FarmerContext';
import FarmerBanks from './components/Users/farmers/FarmerBanks';
import FarmerCustomers from './components/Users/farmers/FarmerCustomers';
import FarmerHotels from './components/Users/farmers/FarmerHotel';
import FarmerTransporter from './components/Users/farmers/FarmerTransporters';
import FarmerCommunicate from './components/Users/farmers/Communicate/FarmerCommunicate';
import FarmerCommunBankOwners from './components/Users/farmers/Communicate/FarmerCommunicateBankOwners';
import FarmerCommunCustomer from './components/Users/farmers/Communicate/FarmerCommunicateCustomer';
import FarmerCommunHotelOwners from './components/Users/farmers/Communicate/FarmerCoomunHotelOwner';
import FarmerCommunTransOwners from './components/Users/farmers/Communicate/FarmerCommunTransOwners';
import FarmerDashLP from './components/Users/farmers/FArmerDashLP';
import { TransportOwnerProvider } from './components/Users/transportOwners/TransportOwnerContext';
import TransOwnerDash from './components/Users/transportOwners/TransportOwnerDash';
import TransOwnerCommun from './components/Users/transportOwners/Communicate/TransOwnerCommun';
import TransOwnerCommunCustomer from './components/Users/transportOwners/Communicate/TransOwnerCommunCustomer';
import TransOwnerCommunFarmer from './components/Users/transportOwners/Communicate/TransOwnerCommunFarmer';
import TransOwnerCommunHotelOwner from './components/Users/transportOwners/Communicate/TransporterCommunHotelOwner';
import TransOwnerCommunAdmin from './components/Users/transportOwners/Communicate/TransOwnerCommunAdmins';
import TransOwnerDashLP from './components/Users/transportOwners/TransOwnersLP';
import ProtectedRoutes from './components/ProtectedRoutes';
import { RegisterAdmin } from "./components/Users/registerAdmin";
import AdminChangeAccount from "./components/Users/Admins/AdminChangeAccount";
import AdminAccount from "./components/Users/Admins/AdminAccount";
import BankOwnerAccount from "./components/Users/bank_owners/BankOwnerAccount";
import BankOwnerAccountChange from "./components/Users/bank_owners/BankOnwerAccount";
import CustomerAccount from "./components/Users/customers/CustomerAccount";
import CustomerChangeAccount from "./components/Users/customers/CustomerChangeAccount";
import FarmerAccount from "./components/Users/farmers/FarmerAccount";
import FarmerAccountChange from "./components/Users/farmers/FarmerAccountChange";
import HotelOwnerAccount from "./components/Users/hotelOwners/HOAccount";
import HotelOwnerChange from "./components/Users/hotelOwners/HOAccountChange";
import TransportOwnerAccount from "./components/Users/transportOwners/TOAccount";
import TransportOwnerChange from "./components/Users/transportOwners/TOAccountChange";
import logo from "./logo.svg"
function App() {
  return (
    <div className="flex h-screen ">
     <NavBar/>
      <div className="main-content overflow-y-auto overflow-x-auto mt-8">
        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route exact path='/about' element={<About/>}/>
          <Route exact path='/contact' element={<Contact/>}/> 
          <Route exact path="/registerAdmin" element={<RegisterAdmin/>}/>   
          <Route exact path='/adminDash' element={         
            <ProtectedRoutes>
              <AdminProvider>
              <AdminDashboard />
            </AdminProvider>
            </ProtectedRoutes>
            
          }>
            <Route exact path='' element={<AdminDashLandingPage />} />
            <Route exact path='hotels' element={<AdminHotelsFunc/>} />
            <Route exact path='banks' element={<AdminBanksFun />} />
            <Route exact path='transporters' element={<AdminTransporters />} />
            <Route exact path="account" element={<AdminAccount/>}>
                 <Route exact path="logout" element={<Logout/>}/>
                 <Route exact path="change" element={<AdminChangeAccount/>}/>
            </Route>
            <Route exact path='communicate' element={<Communicate/>}>
               <Route exact path='bank_owners' element={<CommunicateBankOwner/>}/>
               <Route exact path='customers'  element={<CommunicateCustomer/>}/>
               <Route exact path='farmers'  element={<CommunicateFarmers/>}/>
               <Route exact path='hotel_owners'  element={<CommunicateHotelOwners/>}/>
               <Route exact path='transport_owners'  element={<CommunicateTransportOwners/>}/>
            </Route>            
          </Route>          
          <Route exact path='/customerDash'  element={             
                <ProtectedRoutes>
                  <CustomerProvider>
                  <CustomerDashboard />
                </CustomerProvider>   
                </ProtectedRoutes>           
                } 
            >
              <Route  exact path='' element={<CustomerDashLP/>}/> 
              <Route  exact path='banks' element={<CustomerBanks/>}/>
              <Route  exact path='hotels' element={<CustomerHotels/>}/>
              <Route  exact path='farmers' element={<CustomerFarmers/>}/>                
              <Route exact path='transporters' element={<CustomerTransporter/>}  />
              <Route exact path="account" element={<CustomerAccount/>}>
                <Route exact path="change" element={<CustomerChangeAccount/>}/>
                <Route exact path="logout" element={<Logout/>}/>
              </Route>
              <Route exact path='communicate' element={<CustomerCommun/>}  >
                 <Route exact path='farmers' element={<CommunicateFarmer/>}/>
                 <Route exact path='bankOwners' element={<CustomerCommunBankOwner/>}/>
                 <Route exact path='hotelOwners' element={<CustomerCommunicateHotelOwners/>}/>
                 <Route exact path='transOwners' element={<CustomerCommunTransOwners/>}/>
                 <Route exact path='admins' element={<CustomerCommunAdmins/>}/>
              </Route>
          </Route>
          <Route exact path='/registerUser' element={<Register />} />
          <Route exact path='/loginUser' element={<Login />} />
                    
          <Route exact path='bankOwnerDash' element={
              <ProtectedRoutes>
                <BankOwnerProvider>
                    <BankOwnerDashboard />
                </BankOwnerProvider>
              </ProtectedRoutes>
            } >
                <Route exact path='' element={<BankOwnerDashLP/>}/>
               <Route exact path='banks' element={<BankOwnerBanks/>}/>
               <Route exact path="account" element={<BankOwnerAccount/>}>  
                   <Route exact path="change" element={<BankOwnerAccountChange/>}/>  
                   <Route exact path="logout"  element={<Logout/>}  />        
               </Route>
               <Route exact path='communicate' element={<CommunBankOwner/>}>
                   <Route exact path='customers' element={<CommunCustomer/>}/>
                   <Route exact path='farmers' element={<CommunFarmer/>}/>
                   <Route exact path='admins' element={<CommunicateAdmin/>}/>
               </Route>
            </Route>
            
          <Route exact path='/farmerDash' element={
              <ProtectedRoutes>
                <FarmerProvider>
                  <FarmerDashboard />
                </FarmerProvider>
              </ProtectedRoutes>
            }>
             <Route exact path='' element={<FarmerDashLP/>}/>
             <Route exact path='banks' element={<FarmerBanks/>}/>
             <Route exact path='hotels' element={<FarmerHotels/>}/>
             <Route exact path='customers' element={<FarmerCustomers/>}/>
             <Route exact path='transporters' element={<FarmerTransporter/>}/>
             <Route exact path="account" element={<FarmerAccount/>}>
                <Route exact path="change" element={<FarmerAccountChange/>}/>
                <Route exact path="logout" element={<Logout/>}/>
              </Route>
             <Route exact path='communicate' element={<FarmerCommunicate/>}>
                <Route exact path='admins' element={<FarmerComunAdmin/>}/>
                <Route exact path='bankOwners' element={<FarmerCommunBankOwners/>}/>
                <Route exact path='customers' element={<FarmerCommunCustomer/>}/>
                <Route exact path='hotelOwners' element={<FarmerCommunHotelOwners/>}/>
                <Route exact path='transOwners' element={<FarmerCommunTransOwners/>}/>
             </Route>
          </Route>
          <Route exact path='/hotelOwnerDash' element={
              <ProtectedRoutes>
                <HotelOwnerProvider>
                  <HotelOwnerDashboard />
                </HotelOwnerProvider> 
              </ProtectedRoutes>
            } >
               <Route exact path='' element={<HotelOwnerDashLP/>}/>
              <Route exact path='hotels' element={<HotelOwnerHotels/>}/>
              <Route exact path='communicate' element={<HotelOwnerCommunicate/>}>
                 <Route exact path='customers' element={<HotelOwnerCommunCustomer/>}/>
                 <Route exact path='farmers' element={<HotelOwnerCommunFarmer/>}/>
                 <Route exact path="admins" element={<HotelOnwerCommunAdmin/>}/>
              </Route>
              <Route  exact path="account" element={<HotelOwnerAccount/>}>
                <Route exact path="change" element={<HotelOwnerChange/>}/>
                <Route exact  path="logout" element={<Logout/>}/>
              </Route>
            </Route>
          <Route exact  path='/transportOwnerDash' element={
              <ProtectedRoutes>
                <TransportOwnerProvider>
                  <TransportOwnerDashboard />
                </TransportOwnerProvider>
              </ProtectedRoutes>
            } >
              <Route exact path=''  element={<TransOwnerDashLP/>}/>
              <Route exact path='transporters'  element={<TransOwnerDash/>}/>
              <Route exact path="account" element={<TransportOwnerAccount/>}>
                 <Route exact path="change" element={<TransportOwnerChange/>}/>
                 <Route exact  path="logout" element={<Logout/>}/>
              </Route>
              <Route exact path='communicate'  element={<TransOwnerCommun/>}>              
                <Route exact path='customers'  element={<TransOwnerCommunCustomer/>}/>
                <Route exact path='farmers'  element={<TransOwnerCommunFarmer/>}/>
                <Route exact path='hotelOwners'  element={<TransOwnerCommunHotelOwner/>}/>
                <Route exact path='admins'  element={<TransOwnerCommunAdmin/>}/>               
              </Route>
          </Route>
          <Route exact path='/unauthorized' element={<Unauthorized/>}/>
        </Routes>
      </div>
    </div>
  );
}

export default App;

